import { FlowTheme } from '../types/flow';

export const flowTheme: FlowTheme = {
  edges: {
    agent: {
      type: 'smoothstep',
      animated: true,
      style: { 
        strokeWidth: 3,
        stroke: '#818cf8' // Indigo-400
      },
      markerEnd: {
        type: 'arrowclosed',
        width: 20,
        height: 20,
        color: '#818cf8',
      },
    },
    task: {
      type: 'smoothstep',
      animated: true,
      style: { 
        strokeWidth: 2,
        stroke: '#10b981' // Emerald-500
      },
      markerEnd: {
        type: 'arrowclosed',
        width: 20,
        height: 20,
        color: '#10b981',
      },
    },
    tool: {
      type: 'smoothstep',
      animated: true,
      style: { 
        strokeWidth: 2,
        stroke: '#f59e0b' // Amber-500
      },
      markerEnd: {
        type: 'arrowclosed',
        width: 20,
        height: 20,
        color: '#f59e0b',
      },
    },
    default: {
      type: 'smoothstep',
      animated: true,
      style: { 
        strokeWidth: 2,
        stroke: '#6366f1'
      },
      markerEnd: {
        type: 'arrowclosed',
        width: 20,
        height: 20,
        color: '#6366f1',
      },
    }
  }
};